/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useEffect, useMemo } from 'react';
import { Workspace } from '/views/workspace';
import { useWorkspaceState, WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { WorkspaceContext } from '/views/workspace/workspaceContext';
import { selectDilDefinitionByName } from 'srs-middleware';

/**
 *  A Screen is a View that contains a fixed set of a mixture of Widgets and Views.
 *
 * @param {boolean}       isReady
 * @param {string}        dilName
 * @param listComponent
 * @returns {null|*}
 * @constructor
 */
export const Screen = ({ isReady, dilName, widgetOutFilter, widgetInFilter, widgetOrder, rootResultFilter, children }) => {
  const [state, dispatch] = useWorkspaceState();

  const contextValue = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);

  useEffect(() => {
		if(dilName && isReady){
      const dil = selectDilDefinitionByName(dilName);
      dispatch(WorkspaceActionCreator.updateSelectedDefinition(dil));
    }
  }, [isReady, dispatch, dilName]);

  return (
    <WorkspaceContext.Provider value={contextValue}>
      <Workspace isReady={isReady}
        widgetOutFilter={widgetOutFilter}
        widgetInFilter={widgetInFilter}
        widgetOrder={widgetOrder}
        rootResultFilter={rootResultFilter}
      >
        {children}
      </Workspace>
    </WorkspaceContext.Provider>
  );
};

